import React, { ComponentProps, HTMLProps } from 'react';
import { LinkStyled } from './Link.styles';

type Props = ComponentProps<typeof LinkStyled> & HTMLProps<HTMLAnchorElement>;

export const Link = (props: Props) => {
  return <LinkStyled component="a" {...props} />;
};
